export class MarginModel {
  constructor(data: MarginModel) {
    this.top = data.top;
    this.bottom = data.bottom;
    this.left = data.left;
    this.right = data.right;
    this.width = data.width;
    this.height = data.height;
  }
  top: number;
  bottom: number;
  left: number;
  right: number;
  width?: number;
  height?: number;
}
